import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UserVideoCardWithViews } from 'types/interfaces/user/UserVideoCardWithViews';

type VideoCastState = {
  users: UserVideoCardWithViews[];
  next: string | null;
  loading: boolean;
  initLoading: boolean;
  currentPage: number;
  currentProfilesPackHash: null | string;
};

const initialState: VideoCastState = {
  users: [],
  next: null,
  loading: false,
  initLoading: false,
  currentPage: 1,
  currentProfilesPackHash: null,
};

const videoCastSlice = createSlice({
  name: 'videoCast',
  initialState,
  reducers: {
    addUsers(state, action: PayloadAction<UserVideoCardWithViews[]>) {
      state.users = state.users
        ? [...state.users, ...action.payload]
        : [...action.payload];
    },

    setUsers(state, action: PayloadAction<UserVideoCardWithViews[]>) {
      state.users = action.payload;
    },

    setNext(state, action: PayloadAction<string | null>) {
      state.next = action.payload;
    },

    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setInitLoading(state, action: PayloadAction<boolean>) {
      state.initLoading = action.payload;
    },

    setCurrentPage(state, action: PayloadAction<number>) {
      state.currentPage = action.payload;
    },

    setCurrentProfilesPackHash(state, action: PayloadAction<string>) {
      state.currentProfilesPackHash = action.payload;
    },
  },
});

export const {
  addUsers,
  setUsers,
  setNext,
  setLoading,
  setInitLoading,
  setCurrentPage,
  setCurrentProfilesPackHash,
} = videoCastSlice.actions;

export const videoCast = videoCastSlice.reducer;
